import React from 'react';
import { withStyles } from '@material-ui/core';
import { Autocomplete } from '@mui/material';
import styles from './styles';
import { useVAutocomplete } from './hook';
import VAutocompleteInput from './VAutocompleteInput/VAutocompleteInput';
import VAutocompleteOption from './VAutocompleteOption/VAutocompleteOption';

const VAutocomplete = ({
  classes,
  onSelectOption,
  searchFunction,
  optionLabelKey,
  placeholder = 'Buscar...',
  noOptionsText = 'No hay resultados',
  loadingText = 'Cargando...',
  customOptionComponent,
  ...inputProps
}) => {
  const {
    inputRef,
    openAutocomplete,
    handleOpenAutocomplete,
    handleCloseAutocomplete,
    options,
    searchQuery,
    onChangeSearch,
    isLoading,
    setIsLoading,
    handleSelectOption,
  } = useVAutocomplete(onSelectOption, searchFunction, optionLabelKey);

  return (
    <Autocomplete
      className={classes.autocompleteContainer}
      open={openAutocomplete}
      onOpen={handleOpenAutocomplete}
      onClose={handleCloseAutocomplete}
      options={isLoading ? [] : options}
      loading={isLoading}
      freeSolo={!searchQuery}
      clearOnBlur
      noOptionsText={isLoading ? loadingText : noOptionsText}
      renderInput={(props) => (
        <VAutocompleteInput
          onChange={onChangeSearch}
          placeholder={placeholder}
          ref={inputRef}
          {...props}
          {...inputProps}
        />
      )}
      renderOption={(props, option) => (
        <VAutocompleteOption
          option={option}
          CustomComponent={customOptionComponent}
          searchQuery={searchQuery}
          onSelectOption={handleSelectOption}
          setIsLoadingOption={setIsLoading}
          key={option.label}
        />
      )}
    />
  );
};

export default withStyles(styles)(VAutocomplete);
